import GameOver from '../containers/Game/containers/Screens/GameOver'
import Success from '../containers/Game/containers/Screens/Success'

export default {
  gameOver: GameOver,
  gameCompleted: Success
}



// WEBPACK FOOTER //
// ./src/constants/overlayContent.js